import BoundlessLogo from "@/svg/boundless/logo.svg?react"

export function FundReadyHeader() {
  return (
    <div className="mx-auto flex max-w-4xl items-center justify-between border-b px-8 py-5">
      <BoundlessLogo className="h-6 w-auto max-w-full shrink-0 object-contain" />
      <span className="text-primary text-xs font-semibold tracking-widest uppercase">
        FundReady™
      </span>
    </div>
  )
}
